import styled from 'styled-components';

export const ModalOverlay = styled.div`
  .hefesto-modal__container {
    width: 368px;
  }
  .hefesto-modal__header {
    margin-bottom: 12px;
    h3 {
      font-size: 20px;
      line-height: 28px;
      color: #495961;
      font-weight: 400;
    }
  }
  .hefesto-modal__body {
    color: #414e55;
  }
`;
